import { MantineProvider } from "@mantine/core";
import ReactDOM from "react-dom";
import App from "./App";
import mantineTheme from "./config/mantine.config";
// import * as dotenv from 'dotenv'
// dotenv.config()
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import "react-pdf/dist/esm/Page/TextLayer.css";

ReactDOM.render(
  <MantineProvider theme={mantineTheme}>
    <App />
  </MantineProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
